import { useUISize } from 'app/utils/web-helpers';
import { InterestsScreenBodyLarge } from './interests-screen-body.large';
import { InterestsScreenBodySmall } from './interests-screen-body.small';
import type { InterestsScreenState } from './use-interests-screen';

export type { InterestsScreenState };

export function InterestsScreenBody(state: InterestsScreenState) {
  const { isLargeUI } = useUISize();
  return isLargeUI ? <InterestsScreenBodyLarge {...state} /> : <InterestsScreenBodySmall {...state} />;
}
